import { render, staticRenderFns } from "./Received.vue?vue&type=template&id=09fe5d20&scoped=true"
import script from "./Received.vue?vue&type=script&lang=js"
export * from "./Received.vue?vue&type=script&lang=js"
import style0 from "./Received.vue?vue&type=style&index=0&id=09fe5d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe5d20",
  null
  
)

export default component.exports